import { BasicResponseDTO } from '../../../../../shared/constants';
import { put } from '../../../../../shared/api';

export const updateSchedulerRequest = (rankingId: number, publishDate: string | null): Promise<BasicResponseDTO> => {
  return put(`rankings/${rankingId}/publish`, publishDate ? { publicationDate: publishDate } : null);
};
